import difference from 'lodash/difference'
import isEqual from 'lodash.isequal';
import {
  ApplyOnOptions, 
  InitialUserList
} from './constants'


 const validateMaxLength = (length) => {
   return (value) => {
     return value.length <= length;
   }
}

export const validateLength50 = validateMaxLength(50);
export const validateLength200 = validateMaxLength(200);


const getInSec = (hr, min) =>{
  const hour = hr ? Number(hr) : 0;
  const minute = min ? Number(min)  : 0;
  return  (hour*60*60) + (minute*60);
}


const seperateAliasAndUsers = (list) => {
  const alias = [];
  const users = [];
  if(Array.isArray(list)){
    list.forEach(val => {
      if(val === 'assignee' || val === 'assigner'){
        alias.push(val)
      }else{
        users.push(val);
      }
    })
  }
  return [alias, users];
}

export const createSlaRequestData = (values) => {

  const [od_frt_alias, od_frt_users] = seperateAliasAndUsers(values.overdue_frt_notifiers)
  const [od_rt_alias, od_rt_users] = seperateAliasAndUsers(values.overdue_rt_notifiers)

  const [d_frt_alias, d_frt_users] = seperateAliasAndUsers(values.duesoon_frt_notifiers)
  const [d_rt_alias, d_rt_users] = seperateAliasAndUsers(values.duesoon_rt_notifiers)


  const frtOverDueSec = getInSec(values.overdue_frt_hr, values.overdue_frt_min);
  const rtOverDueSec = getInSec(values.overdue_rt_hr, values.overdue_rt_min);

  const frtDuesoonSec = getInSec(values.duesoon_frt_hr, values.duesoon_frt_min);
  const rtDuesoonSec =  getInSec(values.duesoon_rt_hr, values.duesoon_rt_min);

  return {
    "name": values.name,
    "description": values.description,
    "use_business_hour": values.consider_bh,
    "condition": {
      "conversation": values.apply_sla_on,
      "with_tag": !values.apply_tags || values.apply_tags.length === 0 ? 'any'  : values.tag_type,
      "tags": values.apply_tags ? values.apply_tags : []
    },
    "target": {
      "frt_overdue": frtOverDueSec > 0 ? {
        "time_in_sec": frtOverDueSec,
        "notify_alias": od_frt_alias,
        "notify_users":od_frt_users
      }: null,
      "rt_overdue": rtOverDueSec > 0 ? {
        "time_in_sec": rtOverDueSec,
        "notify_alias": od_rt_alias,
        "notify_users": od_rt_users
      }: null,
      "frt_duesoon": frtDuesoonSec > 0 ? {
        "time_in_sec": frtDuesoonSec,
        "notify_alias": d_frt_alias,
        "notify_users": d_frt_users
      }: null,
      "rt_duesoon": rtDuesoonSec > 0 ? {
        "time_in_sec": rtDuesoonSec,
        "notify_alias": d_rt_alias,
        "notify_users": d_rt_users
      }: null
    }
  }
}

export const createSlaSettingsRequestData = (formData) => {
 const [alias, users]  = seperateAliasAndUsers(formData.users)
 return {
    "apply_on": formData.appliedOn,
    "notify_on_delete": {
      "notify_alias": alias,
      "notify_users": users
    }
  }
}

export const convertSecondsToHourAndMinutes = (sec) => {
  if(sec <= 0){
    return [0, 0];
  }

  const totalMin = sec/60;
  const hour = Math.trunc(totalMin/60);
  const min = totalMin%60;
  return [hour, min];
}


export const convertHoursAndMinutesToSeconds = (hr, min) => {
  let hour = isNaN(hr) ? 0 : hr;
  let minute = isNaN(min) ? 0 : min;
  return (hour*60*60) + (minute*60)
}

export function ascendingSlaCompare(a, b) {
  return a.priority - b.priority
}

export const getArrayData = (data) => {
  return Array.isArray(data) ? data: []
}


export const hasChangesFromInitialValue = (currentValues) => {
  const {
    name, 
    description, 
    apply_sla_on,
    apply_tags,
    tag_type,
    overdue_frt_hr,
    overdue_frt_min,
    overdue_rt_hr,
    overdue_rt_min,
    overdue_frt_notifiers,
    overdue_rt_notifiers,
    duesoon_frt_hr,
    duesoon_frt_min,
    duesoon_rt_hr,
    duesoon_rt_min,
    consider_bh,
    duesoon_frt_notifiers,
    duesoon_rt_notifiers,
  } = currentValues;

  const all = ApplyOnOptions[0].value;
  const assignee = InitialUserList[0].value;
  const assigner = InitialUserList[1].value;
  const intialValue = [assignee, assigner];

  return !!(
    name || 
    description || 
    apply_tags ||
    overdue_frt_hr ||
    overdue_frt_min ||
    overdue_rt_hr ||
    overdue_rt_min ||
    duesoon_frt_hr ||
    duesoon_frt_min ||
    duesoon_rt_hr ||
    duesoon_rt_min ||
    consider_bh ||
    apply_sla_on !== all ||
    tag_type !== 'any_of' ||
    difference(intialValue, overdue_frt_notifiers).length > 0 ||
    difference(intialValue, overdue_rt_notifiers).length > 0 ||
    difference(intialValue, duesoon_frt_notifiers).length > 0 ||
    difference(intialValue, duesoon_rt_notifiers).length > 0
  )
}


export const isSamePreviousValues = (currentFormValues, existingValue) => {
  const {
      name, 
      description, 
      apply_sla_on,
      apply_tags,
      tag_type,
      consider_bh,
      overdue_frt_hr,
      overdue_frt_min,
      overdue_rt_hr,
      overdue_rt_min,
      overdue_frt_notifiers,
      overdue_rt_notifiers,
      duesoon_frt_hr,
      duesoon_frt_min,
      duesoon_rt_hr,
      duesoon_rt_min,
      duesoon_frt_notifiers,
      duesoon_rt_notifiers,
  } = currentFormValues;
  const {name:currentSlaName, description:currentSlaDesc, condition, target, use_business_hour} =  existingValue;

  const nameSame = currentSlaName === name;
  const descSame = currentSlaDesc === description;
  const applyOnSame = apply_sla_on === condition.conversation;
  const applyTagsSame = isEqual(condition.tags, apply_tags);
  const tagTypeSame = tag_type === condition.with_tag;
  const considerBhSame = use_business_hour === consider_bh;

  let {frt_overdue, rt_overdue, frt_duesoon, rt_duesoon } = target;

  const initialValue = {
    notify_alias: ["assignee", "assigner"],
    notify_users: [],
    time_in_sec: 0
  }

  frt_overdue = frt_overdue || initialValue;
  rt_overdue = rt_overdue || initialValue;
  frt_duesoon = frt_duesoon || initialValue;
  rt_duesoon = rt_duesoon || initialValue;

  const overdueFrtSame = convertHoursAndMinutesToSeconds(Number(overdue_frt_hr), Number(overdue_frt_min)) === frt_overdue.time_in_sec
  const overdueRtSame = convertHoursAndMinutesToSeconds(Number(overdue_rt_hr), Number(overdue_rt_min)) === rt_overdue.time_in_sec
  const overdueFrtUsersSame = isEqual([...getArrayData(frt_overdue.notify_alias), ...getArrayData(frt_overdue.notify_users)], overdue_frt_notifiers)
  const overdueRtUsersSame = isEqual([...getArrayData(rt_overdue.notify_alias), ...getArrayData(rt_overdue.notify_users)], overdue_rt_notifiers)

  const duesoonFrtSame = convertHoursAndMinutesToSeconds(Number(duesoon_frt_hr), Number(duesoon_frt_min)) === frt_duesoon.time_in_sec
  const duesoonRtSame = convertHoursAndMinutesToSeconds(Number(duesoon_rt_hr), Number(duesoon_rt_min)) === rt_duesoon.time_in_sec

  const duesoonFrtUsersSame = isEqual([...getArrayData(frt_duesoon.notify_alias), ...getArrayData(frt_duesoon.notify_users)], duesoon_frt_notifiers)
  const duesoonRtUsersSame = isEqual([...getArrayData(rt_duesoon.notify_alias), ...getArrayData(rt_duesoon.notify_users)], duesoon_rt_notifiers)


  return (
      nameSame && descSame && 
      applyOnSame && applyTagsSame && 
      tagTypeSame && 
      overdueFrtSame && overdueRtSame && 
      overdueFrtUsersSame && overdueRtUsersSame && 
      duesoonFrtSame && duesoonRtSame && 
      duesoonFrtUsersSame && duesoonRtUsersSame && considerBhSame
      )
}

export const getDefaultSlaFormData = (notifyUserIdList = [], isDueSoonEnabled = false) => ({
    apply_sla_on: "all",
    tag_type: "any_of",
    consider_bh: false,
    overdue_frt_notifiers: notifyUserIdList,
    overdue_rt_notifiers: notifyUserIdList,
    duesoon_frt_notifiers: notifyUserIdList,
    duesoon_rt_notifiers: notifyUserIdList,
    name: "Default SLA policy",
    overdue_frt_hr: "2",
    overdue_rt_hr: "24",
    duesoon_frt_hr: isDueSoonEnabled? "1" : undefined,
    duesoon_rt_hr: isDueSoonEnabled ? "12" : undefined
});

export const getDefaultSlaSettingsFormData = () => ({
    appliedOn: 'conv_created_or_tag_modified',
    users: ["assignee", "assigner"]
});
